import AgentStudioAPI from '../../api/agentStudio';

export const state = {
  workflows: [],
  workspaces: [],
  uiFlags: {
    isFetchingWorkflows: false,
    isFetchingWorkspaces: false,
  },
};

export const getters = {
  getWorkflows($state) {
    return $state.workflows;
  },
  getWorkspaces($state) {
    return $state.workspaces;
  },
  getWorkflowById: $state => workflowId => {
    return $state.workflows.find(workflow => workflow.id === workflowId);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  fetchWorkflow: async (_, workflowId) => {
    const response = await AgentStudioAPI.fetchWorkflow(workflowId);
    // Backend returns { workflow: {...}, success: true }
    return response.data.workflow || null;
  },
  fetchWorkflows: async ({ commit }, workspaceId = null) => {
    commit('SET_UI_FLAG', { isFetchingWorkflows: true });
    try {
      const response = await AgentStudioAPI.fetchWorkflows(workspaceId);
      // Backend returns { workflows: [...], totalCount: N, organizationId: "..." }
      const workflows = response.data.workflows || [];
      commit('SET_WORKFLOWS', workflows);
      commit('SET_UI_FLAG', { isFetchingWorkflows: false });
      return workflows;
    } catch (error) {
      commit('SET_UI_FLAG', { isFetchingWorkflows: false });
      throw error;
    }
  },
  fetchWorkspaces: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetchingWorkspaces: true });
    try {
      const response = await AgentStudioAPI.fetchWorkspaces();
      // Backend returns { workspaces: [...], totalCount: N, organizationId: "..." }
      const workspaces = response.data.workspaces || [];
      commit('SET_WORKSPACES', workspaces);
      commit('SET_UI_FLAG', { isFetchingWorkspaces: false });
      return workspaces;
    } catch (error) {
      commit('SET_UI_FLAG', { isFetchingWorkspaces: false });
      throw error;
    }
  },
};

export const mutations = {
  SET_WORKFLOWS($state, workflows) {
    $state.workflows = workflows;
  },
  SET_WORKSPACES($state, workspaces) {
    $state.workspaces = workspaces;
  },
  SET_UI_FLAG($state, uiFlag) {
    $state.uiFlags = { ...$state.uiFlags, ...uiFlag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
